import "./src/theme/styles/global.scss"

export const onInitialClientRender = () => {
  // Remove the server-side injected CSS once client-side JSS mounts
  const jssStyles = document.querySelector("#jss-server-side")
  if (jssStyles && jssStyles.parentNode) {
    jssStyles.parentNode.removeChild(jssStyles)
  }
}
